<template>
  <VideoPlayer
    :url="value"
    :class="classes"
    :poster="poster"
    :should-track-events="shouldTrackEvents"
    :video-identifier="videoIdentifier"
  />
</template>

<script>
import VideoPlayer from '@/modules/core/app/components/presentational/VideoPlayer.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'VideoEmbed',
  components: {
    VideoPlayer
  },
  props: {
    value: {
      type: String
    },
    classes: {
      type: Array,
      default: () => []
    },
    poster: {
      type: String,
      default: ''
    },
    shouldTrackEvents: {
      type: Boolean,
      default: false
    },
    videoIdentifier: {
      type: String,
      default: ''
    }
  }
};
</script>
